var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisibleMessage
    ? _c(
        "div",
        { staticClass: "message-content" },
        [
          _vm.collapsableMessage
            ? _c(
                "v-expansion-panel",
                {
                  staticClass: "expansion-panel",
                  attrs: { expand: "" },
                  model: {
                    value: _vm.panel,
                    callback: function($$v) {
                      _vm.panel = $$v
                    },
                    expression: "panel"
                  }
                },
                _vm._l(_vm.dropdownTitles, function(item, i) {
                  return _c(
                    "v-expansion-panel-content",
                    {
                      key: i,
                      attrs: { id: "expansion-panel" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "actions",
                            fn: function() {
                              return [
                                _c("v-icon", { staticClass: "icon-expand" }, [
                                  _vm._v("$vuetify.icons.expand")
                                ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "header",
                            fn: function() {
                              return [_c("div", [_vm._v(_vm._s(item))])]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _vm._v(" "),
                      _vm._v(" "),
                      i === 0
                        ? _c(
                            "div",
                            [
                              _c("viewer", {
                                staticClass: "special-message",
                                attrs: { data: _vm.specialMessage.message }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
            : _c(
                "div",
                [
                  _c("viewer", {
                    staticClass: "special-message",
                    attrs: { data: _vm.specialMessage.message }
                  })
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }